import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import {
  OnboardStatus,
  useGetOrganizationsQuery,
  useWatchOnboardStatusSubscription,
} from "~@/graphql/codegen/generated";

// Хук для подписки на изменения статуса онбординга
const useWatchOnboardStatus = () => {
  const { data: organizationsData } = useGetOrganizationsQuery();

  // Мемоизация текущей организации
  const currentOrganization = useMemo(() => {
    return organizationsData?.getOrganizations?.current;
  }, [organizationsData]);

  const navigate = useNavigate();

  // Подписка на изменения статуса онбординга
  useWatchOnboardStatusSubscription({
    skip: !currentOrganization?.id, // Пропускаем подписку, если нет ID организации или онбординг завершен
    variables: {
      oid: currentOrganization?.id!, // Передаем ID текущей организации
    },
    async onData({
      data: { data: watchOnboardStatusData },
      client: { cache },
    }) {
      const oid = watchOnboardStatusData?.watchOnboardStatus?.oid; // Получаем ID организации из данных подписки
      const status = watchOnboardStatusData?.watchOnboardStatus?.onboardStatus; // Получаем статус онбординга из данных подписки

      if (typeof oid === "string" && typeof status === "string") {
        // Модификация кэша для обновления статуса онбординга
        cache.modify({
          id: cache.identify({
            id: oid, // Идентификатор организации
            __typename: "Organization", // Тип объекта в кэше
          }),
          fields: {
            onboardStatus: () => {
              return status; // Обновляем статус онбординга новыми данными
            },
          },
        });

        // Навигация в зависимости от статуса онбординга
        if (status === OnboardStatus.AddPayment) {
          navigate("/welcome/payment-method"); // Перенаправление на страницу установки пароля
        }
      }
    },
  });
};

export default useWatchOnboardStatus;
